import { css } from '@emotion/react';
import { type FC } from 'react';
import { type ColorResult } from '~/_shared/components/colorPicker/colorPicker.types';
import { ColorPickerWithWheelAndTileComponent } from '~/_shared/components/colorPicker/colorPickerWithTileAndWheel/colorPickerWithTileAndWheel.component';
import { useTranslation } from '~/_shared/utils/hooks';

const dropdownHeadingStyle = css({
  margin: '0 0 7px',
  textTransform: 'uppercase',
  fontSize: '16px',
});

const colorTileContainerStyle = css({
  height: 40,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-around',
});

type LineColorProps = Readonly<{
  className?: string;
  lineColor: ColorResult;
  onLineColorChange: (color: ColorResult) => void;
}>;

export const LineColorComponent: FC<LineColorProps> = (props) => {
  const [t] = useTranslation();

  const { lineColor, onLineColorChange } = props;

  return (
    <div css={props.className}>
      <p css={dropdownHeadingStyle}>{t('Line Color')}</p>
      <div css={colorTileContainerStyle}>
        <ColorPickerWithWheelAndTileComponent
          selectedColor={lineColor}
          onChange={onLineColorChange}
          displayAlpha={false}
        />
      </div>
    </div>
  );
};
